import {
  CALENDARIO_INICIA,
  CALENDARIO_NOVO,
  CALENDARIO_SALVA_SUCESSO,
  CALENDARIO_BUSCA_EDICAO_SUCESSO,
  CALENDARIO_LISTA_TODOS_SUCESSO,
  CALENDARIO_LISTA_ESCOLAS_SUCESSO,
  CALENDARIO_CARREGA_DIAS_SUCESSO,
  CALENDARIO_CARREGA_TIPOS_EVENTO_SUCESSO,
  CALENDARIO_LISTA_TURMAS_SUCESSO,
  CALENDARIO_SALVA_ANOTACAO_SUCESSO,
  CALENDARIO_REMOVE_ANOTACAO_SUCESSO,
  CALENDARIO_SALVA_EVENTO_DIA_SUCESSO,
  CALENDARIO_REMOVE_EVENTO_DIA_SUCESSO,
  CALENDARIO_SELECIONA_DIA,
  CALENDARIO_LIMPAR,
  CALENDARIO_ERRO
} from 'constants/CalendarioTypes';
import { ON_SHOW_LOADER, ON_HIDE_LOADER, ON_SHOW_SUCCESS_MESSAGE, SHOW_MESSAGE, HIDE_MESSAGE } from 'constants/ActionTypes';

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessageError: false,
  showMessageSuccess: false,
  
  // Dados principais
  listaCalendarios: [], // Lista para exibição/seleção
  calendarioAtual: null, // { id, escola_id, ano }
  dias: [], // Lista de dias com eventos/anotações
  
  // Dados auxiliares
  escolas: [],
  tiposEvento: [],
  turmas: [],
  
  // Estado de UI
  diaSelecionado: null,
  modoEdicao: false, // Se está criando novo calendário
  formNovo: {
    escola_id: '',
    ano: ''
  }
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case CALENDARIO_INICIA: {
      return {
        ...INIT_STATE
      };
    }
    
    case CALENDARIO_NOVO: {
      return {
        ...state,
        modoEdicao: true,
        calendarioAtual: null,
        dias: []
      };
    }
    
    case CALENDARIO_SALVA_SUCESSO: {
      return {
        ...state,
        modoEdicao: false,
        calendarioAtual: action.payload,
        loader: false
      };
    }
    
    case CALENDARIO_BUSCA_EDICAO_SUCESSO: {
      return {
        ...state,
        calendarioAtual: action.payload,
        modoEdicao: false,
        loader: false
      };
    }
    
    case CALENDARIO_LISTA_TODOS_SUCESSO: {
      return {
        ...state,
        listaCalendarios: action.payload,
        loader: false
      };
    }
    
    case CALENDARIO_LISTA_ESCOLAS_SUCESSO: {
      return {
        ...state,
        escolas: action.payload
      };
    }

    case CALENDARIO_CARREGA_DIAS_SUCESSO: {
      return {
        ...state,
        dias: action.payload,
        loader: false
      };
    }
    
    case CALENDARIO_CARREGA_TIPOS_EVENTO_SUCESSO: {
      return {
        ...state,
        tiposEvento: action.payload
      };
    }
    
    case CALENDARIO_LISTA_TURMAS_SUCESSO: {
      return {
        ...state,
        turmas: action.payload
      };
    }
    
    case CALENDARIO_SELECIONA_DIA: {
      return {
        ...state,
        diaSelecionado: action.payload
      };
    }
    
    case CALENDARIO_LIMPAR: {
      return INIT_STATE;
    }
    
    case CALENDARIO_ERRO: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessageError: true,
        loader: false
      };
    }

    case ON_SHOW_LOADER: {
      return { ...state, loader: true };
    }
    
    case ON_HIDE_LOADER: {
      return { ...state, loader: false };
    }
    
    case ON_SHOW_SUCCESS_MESSAGE: {
      return { ...state, alertMessage: action.payload, showMessageSuccess: true, showMessageError: false, loader: false };
    }
    
    case SHOW_MESSAGE: {
      return { ...state, alertMessage: action.payload, showMessageError: true, showMessageSuccess: false };
    }
    
    case HIDE_MESSAGE: {
      return { ...state, alertMessage: '', showMessageSuccess: false, showMessageError: false };
    }
    
    default:
      return state;
  }
};
